import { useAnalytics } from '#app/hooks/useAnalytics.js';
import { MenuContext, type MenuContextProps } from './MenuContext.js';
import { type ReactNode, useCallback, useMemo, useState } from 'react';

type Callout = 'switcher' | null;

export const MenuProvider = ({
  children,
}: {
  readonly children: ReactNode;
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);
  const [menuContext, setMenuContext] = useState<
    MenuContextProps['menuContext']
  >({
    callout: null,
  });

  const { track } = useAnalytics();

  const toggleMenu = useCallback(
    (newMenuContext?: { callout: Callout }) => {
      if (!isMenuOpen)
        track('menu', { action: 'tapped', menu_name: 'navigation' });

      if (newMenuContext) {
        setMenuContext(newMenuContext);
      }

      setIsMenuOpen((currentState) => !currentState);
    },
    [isMenuOpen, track],
  );

  const context = useMemo(() => {
    return {
      isMenuOpen,
      menuContext,
      toggleMenu,
    };
  }, [isMenuOpen, menuContext, toggleMenu]);

  return (
    <MenuContext.Provider value={context}>{children}</MenuContext.Provider>
  );
};
